import ExpandingButton from 'components/ExpandingButton';

import ButtonContent from './ButtonContent';
import MainContent from './MainContent';

const MobileHelpButton: React.FunctionComponent = function () {
  return (
    <div className="block md:hidden w-full sticky bottom-0">
      <ExpandingButton
        button={<ButtonContent />}
        buttonId="mobile-help"
        content={<MainContent />}
        direction="up"
      />
    </div>
  );
};

export default MobileHelpButton;
